import React from "react";
import { useLocation } from "react-router-dom";
import SEModuleSubtopic from "../SEModuleSubtopic";

const SoftwareRequirements = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <SEModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Software Requirements"
      videos={[
        "https://www.youtube.com/embed/x5fEGeEHLog?si=6Ew5U1eyM7uUXOpn",
        "https://www.youtube.com/embed/CN-qsm1f_aY?si=wH4NBzi5cP4gdmCo",
        "https://www.youtube.com/embed/aorzuTjBE6A?si=tyhgpVe7lbqMT4bZ",
        "https://www.youtube.com/embed/83-S5Qu6VP8?si=T-oNPYD0cizCCxgd",
        "https://www.youtube.com/embed/SDz2KUyAbmk?si=2xPTaUHqbv8twBWx"
      ]}
      takeaways={[]}
      questions={[
        "You have been given the responsibility to elicit requirements from a customer who tells you “he is too busy to meet with you”. Identify any two suitable elicitation techniques to collect the requirements from the customer. Justify your answer with explanation of suitable process and necessary examples.",
        "A multinational company is developing a comprehensive project management software tool for its distributed teams across different time zones and continents. Identify any three functional and two non-functional requirements to support the tool based on the scenario.",
        "The university aims to develop an ERP system. As the project manager of XY Software Development Organization, explain and identify: (i) User Requirements (ii) System Requirements (iii) Stakeholders (Direct, Indirect) (iv) Functional Requirements (2) (v) Non-functional Requirements (2).",
        "A team must create a healthcare monitoring system for elderly patients where only broad objectives are given. Evaluate how the key tasks of requirements engineering would be applied to develop this system.",
        "Imagine you are developing an online food delivery app. Explain how you would identify and differentiate between functional and non-functional requirements in early stages. Provide at least five examples for each."
      ]}
      exampleVideos={[]}
    />
  );
}

export default SoftwareRequirements;
